import { Button } from '@/shared/components/ui/button'
import { cn } from '@/shared/lib/utils'
import { CharacterVariant } from '@storyverse/shared'
import { Layers, Plus } from 'lucide-react'
import React from 'react'

interface CharacterVariantSelectorProps {
    variants: CharacterVariant[] | undefined
    selectedVariantId: string | null
    onSelectVariant: (id: string) => void
    onAddVariant: () => void
}

export const CharacterVariantSelector: React.FC<CharacterVariantSelectorProps> = ({
    variants,
    selectedVariantId,
    onSelectVariant,
    onAddVariant
}) => {
    return (
        <div className="space-y-4">
            <div className="flex items-center justify-between px-2">
                <div className="flex items-center gap-2">
                    <Layers className="w-5 h-5 text-primary" />
                    <h3 className="text-sm font-bold uppercase tracking-widest text-muted-foreground">Character Variants</h3>
                </div>
                <Button
                    variant="outline"
                    size="sm"
                    onClick={onAddVariant}
                    className="h-8 gap-2 rounded-full border-primary/20 hover:border-primary/50"
                >
                    <Plus className="h-3.5 w-3.5" />
                    <span className="text-xs uppercase font-bold tracking-wider">Add Variant</span>
                </Button>
            </div>

            <div className="flex items-center gap-3 overflow-x-auto pb-4 px-4 scrollbar-none snap-x">
                {variants?.map((v: CharacterVariant) => (
                    <button
                        key={v.id}
                        onClick={() => onSelectVariant(v.id)}
                        className={cn(
                            "flex-shrink-0 px-4 py-2 rounded-full text-xs font-bold uppercase tracking-wider transition-all border",
                            selectedVariantId === v.id
                                ? "bg-primary text-primary-foreground border-primary shadow-md scale-105"
                                : "bg-muted/50 text-muted-foreground border-transparent hover:border-border/50"
                        )}
                    >
                        {v.label}
                        {v.isDefault && <span className="ml-2 text-[8px] opacity-70">(Default)</span>}
                    </button>
                ))}
            </div>
        </div>
    )
}
